export default "__VITE_ASSET__mYZOSSCE__"